var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { t } from '../../../strings/i18n/i18n';
import styled from 'styled-components';
import { fontWeights, spacing } from 'syf-component-library/defaultTheme';
import { getLanguageFromStorage } from 'syf-js-utilities';
import Icon from '../../../ui/atoms/Icon';
import { translations } from './helpers';
var customStyles = function (language) {
    if (language === void 0) { language = 'en'; }
    return ({
        postedDate: "\n    flex: 0 0 ".concat(language === 'en' ? 64 : 70, "px;\n    margin-right: ").concat(spacing.base, "px;\n  "),
        claimId: "\n    flex: 0 0 100px;\n    padding-right: ".concat(language === 'en' ? spacing.xxlarge : spacing.base, "px;\n  "),
        description: "\n    flex: 0 0 40px;\n  ",
        amount: "\n    flex: 0 0 84px;\n  "
    });
};
var TableHeaderButton = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: unset;\n  cursor: pointer;\n  background-color: unset;\n  text-align: left;\n  border: unset;\n  font-weight: ", ";\n\n  &:last-child {\n    margin-left: auto;\n  }\n\n  ", "\n"], ["\n  padding: unset;\n  cursor: pointer;\n  background-color: unset;\n  text-align: left;\n  border: unset;\n  font-weight: ", ";\n\n  &:last-child {\n    margin-left: auto;\n  }\n\n  ", "\n"])), fontWeights.bold, function (_a) {
    var $name = _a.$name, $language = _a.$language;
    return customStyles($language)[$name];
});
var TableHeaderText = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  font-weight: ", ";\n\n  ", "\n"], ["\n  display: flex;\n  font-weight: ", ";\n\n  ", "\n"])), fontWeights.bold, function (_a) {
    var $name = _a.$name;
    return customStyles()[$name];
});
var SortIcon = styled(Icon)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-left: ", "px;\n"], ["\n  margin-left: ", "px;\n"])), spacing.small);
var TableHeader = function (_a) {
    var text = _a.text, sorting = _a.sorting, $name = _a.$name;
    var language = getLanguageFromStorage();
    if (!sorting) {
        return _jsx(TableHeaderText, __assign({ "$name": $name }, { children: text }));
    }
    return (_jsxs(TableHeaderButton, __assign({ role: "button", "aria-label": "".concat(t('sorter.sortOrder', {
            type: text,
            direction: translations[language][sorting.order === 1 ? 1 : 0],
            lng: language
        })), onClick: sorting.onToggle, "$name": $name, "$language": language }, { children: [text, _jsx(SortIcon, { name: sorting.order === 1 ? 'faCaretDown' : 'faCaretUp', size: "1x" })] })));
};
export default TableHeader;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=TableHeader.js.map